let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dFn17")).then(() => parcelRequire('6vvjk'));